import React, { Component } from "react";
import BsyTableList from "../BsyTableList";
import BsySearchInput from "../BsySearchInput";
import BsyAlertListDetail from '../BsyAlertListDetail'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlertInviteUser from "../BsyAlertInviteUser";
import { BsyUtils } from "../../utils/Utils";
import BsyDialog from '../BsyDialog';
import CorpCoopDeatilsPane from "./CorpCoopDeatilsPane";
import CorpCoopRolePane from './CorpCoopRolePane';
import AddRoleUserPane from './AddRoleUserPane';
import AddRoleDeptPane from './AddRoleDeptPane';
import emptyImg2 from "../../images/img_qiye@2x.png";
import emptyImg3 from "../../images/img_sousuo@2x.png";
import './index.css';

export default class CorpCoopOtherSetPane extends Component{
    constructor(props) {
        super(props);
        this.state = {
            filterText: React.language('all'),
            corpCoopList: [],
            contactList: [],
            corpList:[],
            hasCount: true,
            limit: 20,
            skip: 0,
            filter: "",
            miniAppSet: false, //小程序设置
            isCheck: false,
            selectGroup: 'contactAll',
            selectType: 'contactAll',
            selectGroupName: React.language("contact.corp.all"),
            openurl: '',
            inviteStatus: 0,
            role_id: 0,
            openurl_switch: false,
            audit_switch: false,
            userCont: {},
            nocheck: false, //批量导入外部联系不 不验证
            checkList: [],
            checkListDetail: [],
            deptList: [],
            owner_coprs: [],
            keyword:"",
            isLoading: true,
            hasGuestCorp: false,
        }
        this.corpContEl = React.createRef();
    }

    componentDidMount(){
        this.RefreshList(true);
    }

    RefreshList = (noRefres) =>{
        const {selectGroup, limit, skip, keyword, role_id, inviteStatus} = this.state;
        this.setState({isLoading: !!noRefres},()=>{
            this.refreshlist = setTimeout(()=>{
                if(selectGroup === "contactAll"){
                    React.axios("/corp/dock/corp/list_docker",{
                        keyword, limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        this.refreshlist && clearTimeout(this.refreshlist);
                        let deptMapList = {};
                        let guestMapList = {};
                        let hostMapList = {};
                        res2.data.dept_list.map(res=>{
                            res.id = res._id;
                            return deptMapList[res.departmentId] = res;
                        })
                        res2.data.guest_corp_list.map(res=>{
                            return guestMapList[res.dock_corpid] = res;
                        })
                        res2.data.host_corp_list.map(res=>{
                            return hostMapList[res.dock_corpid] = res;
                        })
                        this.setState({
                            corpList: res2.data.our_docker_list.map((val)=>{
                                val.id = val.id;
                                return val;
                            }),
                            deptList: res2.data.dept_list,
                            owner_coprs: res2.data.owner_coprs,
                            deptMapList,
                            guestMapList,
                            hostMapList,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        })
                        this.closeCheckMenu();
                    })
                }else if(selectGroup === "corpDeptAll"){
                    React.axios("/corp/dock/corp/list_dept",{
                        keyword, limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        this.refreshlist && clearTimeout(this.refreshlist);
                        let deptMapList = {};
                        let guestMapList = {};
                        let hostMapList = {};
                        res2.data.guest_corp_list.map(res=>{
                            return guestMapList[res.dock_corpid] = res;
                        })
                        res2.data.host_corp_list.map(res=>{
                            return hostMapList[res.dock_corpid] = res;
                        })
                        this.setState({
                            corpList: res2.data.our_dept_list.map((val)=>{
                                val.id = val.id;
                                return val;
                            }),
                            owner_coprs: res2.data.owner_coprs,
                            deptMapList,
                            guestMapList,
                            hostMapList,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        })
                        this.closeCheckMenu();
                    })
                }else{
                    React.axios("/corp/dock/corp/guest_list",{
                        keyword, limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        this.refreshlist && clearTimeout(this.refreshlist);
                        this.setState({
                            corpList: res2.data.guest_corp_list,
                            owner_coprs: res2.data.owner_coprs,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        })
                        this.closeCheckMenu();
                    })
                }
            },30)
        })
        
    }

    outsiderNodeClick = (node, e) => {
        if(this.state.selectGroup === node.id){
            return
        }
        this.setState({
            limit: 20,
            skip: 0,
            role_id: node.id,
            selectGroup: node.id,
            filter: "",
            inviteStatus: 0,
            keyword:"",
            checkList:[],
            checkListDetail: [], 
            checked: false,
            selectType: e,
            selectGroupName: node ? node.name : React.language("contact.corp.all"),
        }, () => {
            this.RefreshList();
            // this.get_approve_list();
        })
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        // const first = result.splice(0, 1);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    outsiderGroupNodeMove = (attr) => {

        const customGroup = [...this.state.outsiders];
        const groupList = this.reorder(
            customGroup,
            attr.source.index,
            attr.destination.index
        );
        const outsiders = [...groupList];

        let data = {
            "group_id": attr.draggableId,  //被移动的成员
            "prev": attr.destination.index === 0 ? "" : outsiders[attr.destination.index].id
        }
        this.setState({
            outsiders: outsiders
        }, () => {
            React.axios('/corp/outsider/sort', data).then(res => {

            }).catch(res => {

            })
        });
    }

    outsiderNodeAdd = () => {
        const _this = this;
        var f = new window.FX.ConfirmDialog({
            title: React.language("outsider.add"),
            width: 340,
            height: 170,
            text4Ok: React.language("add"),
            contentWidget: {
                rowSize: [30],
                colSize: [300],
                padding: 20,
                items: [[{
                    type: "text",
                    widgetName: "groupName",
                    waterMark: React.language('outsider.name.required'),
                    allowBlank: !1
                }]]
            },
            onOk: function () {
                var g = this.getWidgetByName("groupName");
                var value = g.getValue();
                if (!value) {
                    tipAlert({
                        type: "warning",
                        msg: React.language('outsider.name.empty')
                    })
                    return;
                }
                React.axios("/corp/outsider/create",
                    { "name": value })
                    .then(res => {
                        BsyUtils.showAjaxTip(res.data, () => {
                            const newOutsiders = [..._this.state.outsiders, ...[res.data.data]]
                            _this.setState({ outsiders: newOutsiders })
                            f.close()
                        })
                    }).catch(res => {
                        console.log(res)
                    })
            }
        });
        f.show()
    }

    eventCustMent = (type, node) => {

        const { outsiders, selectType } = this.state;
        switch (type) {
            case "del": {
                BsyAlert({
                    title: React.language("delete.confirm", {
                        name: node.name
                    }),
                    msg: selectType === "corpCoopAll" ? React.language("corp.coop.delete.tip") : selectType === "contactAll" ? React.language("corp.role.delete.tip") : "",
                    type: "warning",
                    text4Ok: React.language("delete"),
                    OkType: "red",
                    text4Cancel: React.language("cancel"),
                    ok: () => {

                        React.axios("/corp/outsider/remove", {
                            group_id: node.id
                        }).then(res => {

                            BsyUtils.showAjaxTip(res.data, () => {
                                const newOutsiders = outsiders.filter((item, index) => {
                                    return item.id !== node.id;

                                })
                                this.setState({ outsiders: newOutsiders })
                            })

                        }).catch(res => {

                        })
                    }
                })
                break;
            }
            case 'rename': {
                const _this = this;
                var f = new window.FX.ConfirmDialog({
                    title: React.language("outsider.group.edit"),
                    width: 340,
                    height: 170,
                    text4Ok: React.language("ok"),
                    contentWidget: {
                        rowSize: [30],
                        colSize: [300],
                        padding: 20,
                        items: [[{
                            type: "text",
                            value: node.name,
                            widgetName: "groupName",
                            allowBlank: !1
                        }]]
                    },
                    onOk: function () {
                        var g = this.getWidgetByName("groupName");
                        var value = g.getValue();
                        if (!value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('outsider.name.empty')
                            })
                            return;
                        }
                        if (node.name === value) {
                            f.close()
                            return;
                        }

                        React.axios("/corp/outsider/update",
                            { "name": value, "group_id": node.id })
                            .then(res => {

                                BsyUtils.showAjaxTip(res.data, () => {

                                    const newOutsiders = outsiders.map((item, index) => {
                                        if (item.id === node.id) {
                                            item.name = value;
                                        }
                                        return item;
                                    })
                                    _this.setState({ outsiders: newOutsiders })
                                    f.close()
                                })

                            }).catch(res => {
                                // console.log(res)
                            })
                    }
                });
                f.show()
                break;
            }
            default: {

            }
        }
    }
    
    outsiderGroupMoreOperate = (e, node) => {
        if (node.type == 1) {
            this.eventCustMent('rename', node);
        } else {
            let menu = [{
                text: React.language('rename'),
                colorType: "",
                click: (event) => {
                    this.eventCustMent('rename', node, event);
                }
            }, {
                text: React.language('delete'),
                colorType: "red",
                click: () => {
                    this.eventCustMent('del', node);
                }
            }]
            BsyAlertMenu({
                item: menu,
                width: 140,
                target: e.currentTarget,
            })

        }

    }

    getCorpUserValue = (e) =>{
        this.addCorpUserEl = e;
    }

    getCorpDeptValue = (e) =>{
        this.addCorpDeptEl = e;
    }

    openNewConnection = () =>{
        const { corpCoopList, contactList } = this.state;
        BsyAlertInviteUser({
            title: React.language('contact.connection.new'),
            styleCss: {
                width: 966,
                height: 620
            },
            type:"corpCoop",
            corpCoopList,
            contactList,
            onRefresh: () => {
                this.RefreshList()
            },
        })
    }

    skipChange = (e) =>{
        this.setState({skip: e},()=>{this.RefreshList()})
    }

    listLimitChange = (e) =>{
        this.setState({limit: e},()=>{this.RefreshList()})
    }

    listFilterChange = (e) =>{
        console.log(e)
    }
    
    handleUserOrder = (e) =>{
        console.log(e)
    }

    againAllInvite = (e) =>{
        console.log(e)
    }

    removeCorpLabelBatch = () =>{
        const {selectGroup, selectType, checkList} = this.state;
        let titile = '', msg = '';
        if(selectGroup === "corpCoopAll"){
            titile = React.language("contact.connection.selected.remove");
            msg = React.language("contact.connection.selected.remove.tip");
            
        }else if(selectGroup === "corpDeptAll") {
            titile = React.language("contact.our.dept.remove.title");
            msg = React.language("contact.our.dept.remove.tip");
        }else{
            titile = React.language("contact.our.docker.remove.title");
            msg = React.language("contact.our.docker.remove.tip");
        } 
        BsyAlert({
            title: titile,
            msg: msg,
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(selectGroup === "corpCoopAll"){
                    React.axios("/corp/dock/corp/delete",{corp_id: checkList, type: "guest_corp"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }else if(selectGroup === "corpDeptAll"){
                    React.axios("/corp/dock/dept/remove",{corp_id: [], dept_id: checkList, type: "guest_corp"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }else{
                    React.axios("/corp/dock/member/remove",{corp_id: [], user_id: checkList, mode: "guest"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }
            }
        })
    }

    removeCorpLabel = (item) =>{
        const {selectGroup} = this.state;
        let titile = '', msg = '';
        if(selectGroup === "corpCoopAll"){
            titile = React.language("contact.connection.selected.remove");
            msg = React.language("contact.connection.selected.remove.tip");
            
        }else if(selectGroup === "corpDeptAll"){
            titile = React.language("contact.our.dept.remove.title");
            msg = React.language("contact.our.dept.remove.tip");
        }else{
            titile = React.language("contact.our.docker.remove.title");
            msg = React.language("contact.our.docker.remove.tip");
        } 
        BsyAlert({
            title: titile,
            msg: msg,
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(selectGroup === "corpCoopAll"){
                    React.axios("/corp/dock/corp/delete",{corp_id: [item._id], type: "guest_corp"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }else if(selectGroup === "corpDeptAll"){
                    React.axios("/corp/dock/dept/remove",{corp_id: [], dept_id: [item.dept_id], mode: "guest"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }else{
                    React.axios("/corp/dock/member/remove",{corp_id: [], user_id: [item.user_id], mode: "guest"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        this.RefreshList();
                    })
                }
            }
        })
    }

    memberRowClick = (event, item) =>{
        const {selectGroup, corpCoopMap, contactMap, selectType, corpCoopList, deptMapList, guestMapList, hostMapList, owner_coprs } = this.state;
        
        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {
            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    if(selectGroup === "corpCoopAll"){
                        BsyAlertListDetail({
                            type: "custom",
                            width: 700,
                            createContent:(e)=>{
                                return <CorpCoopDeatilsPane owner_coprs={owner_coprs} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopList={corpCoopList} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} isOther={true} />
                            }
                        })
                    }else if(selectGroup === "corpDeptAll"){
                        BsyAlertListDetail({
                            type: "custom",
                            width: 400,
                            clsName: "BsyAlertCorpCoopRolePane",
                            createContent:(e)=>{
                                return <CorpCoopRolePane isCorpDept={true} owner_coprs={owner_coprs} RefreshList={this.RefreshList} deptMapList={deptMapList} guestMapList={guestMapList} hostMapList={hostMapList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} isOther={true} onChangeDockCorpName={this.onChangeDockCorpName} />
                            }
                        })
                    }else{
                        BsyAlertListDetail({
                            type: "custom",
                            width: 400,
                            clsName: "BsyAlertCorpCoopRolePane",
                            createContent:(e)=>{
                                return <CorpCoopRolePane owner_coprs={owner_coprs} RefreshList={this.RefreshList} deptMapList={deptMapList} guestMapList={guestMapList} hostMapList={hostMapList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} isOther={true} onChangeDockCorpName={this.onChangeDockCorpName} />
                            }
                        })
                    } 
                }
            },{
                text: selectGroup === "corpCoopAll" ? React.language('contact.connection.remove') : React.language('remove.out'),
                colorType: "red",
                click: () => {
                    this.removeCorpLabel(item)
                }
            }];

            BsyAlertMenu({
                item: menu,
                // renderEl: event.currentTarget,
                width: 140,
                target: event.target
            })
        }  else if (event.target.classList[1] === "again") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            this.againAllInvite(item._id)

        } else {
            if(selectGroup === "corpCoopAll"){
                BsyAlertListDetail({
                    type: "custom",
                    width: 700,
                    createContent:(e)=>{
                        return <CorpCoopDeatilsPane owner_coprs={owner_coprs} RefreshList={this.RefreshList} newProps={e} item={item} corpCoopList={corpCoopList} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} onChangeDockCorpName={this.onChangeDockCorpName} isOther={true} />
                    }
                })
            }else if(selectGroup === "corpDeptAll"){
                BsyAlertListDetail({
                    type: "custom",
                    width: 400,
                    clsName: "BsyAlertCorpCoopRolePane",
                    createContent:(e)=>{
                        return <CorpCoopRolePane isCorpDept={true} owner_coprs={owner_coprs} RefreshList={this.RefreshList} deptMapList={deptMapList} guestMapList={guestMapList} hostMapList={hostMapList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} isOther={true} onChangeDockCorpName={this.onChangeDockCorpName} />
                    }
                })
            }else{
                BsyAlertListDetail({
                    type: "custom",
                    width: 400,
                    clsName: "BsyAlertCorpCoopRolePane",
                    createContent:(e)=>{
                        return <CorpCoopRolePane owner_coprs={owner_coprs} RefreshList={this.RefreshList} deptMapList={deptMapList} guestMapList={guestMapList} hostMapList={hostMapList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} isOther={true} onChangeDockCorpName={this.onChangeDockCorpName} />
                    }
                })
            } 
        }
    }

    onChangeDockCorpName = (item) =>{
        const {corpList} = this.state;
        let corpItme = corpList;
        corpItme.map((val)=>{
            if(val.id === item.id){
                val = item;
            }
        })
        this.setState({corpList:corpItme})
    }

    verifyEmailMobile = () =>{

    }

    getSearchValue = () =>{

    }

    onSearch = (e) =>{
        this.setState({keyword: e},() =>{
            this.RefreshList()
        })
    }

    filterPane = (event, type) => {
        let bts = [
          { icon: '', text: React.language('all'), click: () =>{
            this.setState({filterText: React.language('all'), inviteStatus: 0},()=>{
                this.RefreshList()
            })
          }},
          { icon: '', text: React.language('member.inviting'), click: () =>{
            this.setState({filterText: React.language('member.inviting'), inviteStatus: 1},()=>{
                this.RefreshList()
            })
          }},
        ]
        BsyAlertMenu({
          item: bts,
          width: 120,
          target: event.target,
          customCls: ' data-manage-batch-menu ',
        })
    }

    onBsyTurnPageMid = () => {
        const { not_verified } = this.state;
        return <>
            {not_verified > 0 && <div className="tip-list">
                
                <div className="joined-tip tip-item" onClick={e => { this.againAllInvite() }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div dangerouslySetInnerHTML={{ __html: React.language('contact.corp.not.connection.tip', { count: not_verified }) }} />
                </div>
                <div className="validate-tip tip-item" onClick={e => { this.againAllValidate() }}  >
                    {/* <i className={'icon-bsy-laba'} /> */}
                    <div>{React.language('member.invite.link.copy')}</div>
                </div>
            </div>}
        </>
    }

    getTableValue = (rel) => {
        this.tableValue = rel;
        console.log(rel)
    }

    onCheck = (e) =>{
        this.setState({checkList: e.checkList, checkListDetail: e.checkListDetail, checked: e.checked})
    }

    closeCheckMenu = () =>{
        this.setState({checkList: [], checkListDetail: [], checked: false})
    }

    openAddRoleUserPane = () =>{
        const {corpList, selectGroup} = this.state;

        BsyDialog({
            title: React.language('contact.handover.add'),
            height: 460,
            width: 460,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddRoleUserPane isCoop={true} getEl={this.getCorpUserValue} corpList={corpList} selectGroup={selectGroup} />
            },
            onOk: ()=>{
                if(this.addCorpUserEl.state.user_id_list.length <= 0){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('contact.docking.people.require')
                    })
                    return !1
                }
                this.addCoopData();
            }
        })
    }

    openAddRoleDeptPane = () =>{
        const {corpList, selectGroup} = this.state;

        BsyDialog({
            title: React.language('contact.handover.dept.add'),
            height: 460,
            width: 460,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddRoleDeptPane isCoop={true} getEl={this.getCorpDeptValue} corpList={corpList} selectGroup={selectGroup} />
            },
            onOk: ()=>{
                if(this.addCorpDeptEl.state.dept_id_list.length <= 0){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('contact.docking.dept.require')
                    })
                    return !1
                }
                this.addCoopDeptData();
            }
        })
    }
    addCoopDeptData = () =>{

        React.axios("/corp/dock/dept/add",{
            dept_id_list: this.addCorpDeptEl.state.dept_id_list,
            is_global_docker: this.addCorpDeptEl.state.is_global_docker,
            dock_corpid: this.addCorpDeptEl.state.dock_corpid,
        }).then(res=>{
            if(res.data.errcode === 1){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            this.RefreshList();
        })
    }
    addCoopData = () =>{

        React.axios("/corp/dock/member/add",{
            user_id_list: this.addCorpUserEl.state.user_id_list,
            is_global_docker: this.addCorpUserEl.state.is_global_docker,
            dock_corpid: this.addCorpUserEl.state.dock_corpid,
        }).then(res=>{
            if(res.data.errcode === 1){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            this.RefreshList();
        })
    }

    changeCorpType = (t) =>{
        const { selectGroup, keyword, limit, skip, role_id, inviteStatus } = this.state;
        if(t === selectGroup){
            return
        }
        let mask = window.FX.Utils.createLoadLayer(window.$(this.corpContEl.current), {
            hasLoader: !0
        })
        const selectGroupName = t === "contactAll" ? React.language('contact.handover.current') : t === "corpDeptAll" ? React.language('contact.handover.current.dept') : t === "corpCoopAll" ? React.language('contact.corp.host') : "";
        this.setState({selectGroup: t, isLoading: true, selectGroupName, checkList:[], checkListDetail: [], checked: false, keyword:"",},()=>{
            switch(t){
                case "contactAll":{
                    React.axios("/corp/dock/corp/list_docker",{
                        keyword: "", limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        let deptMapList = {};
                        let guestMapList = {};
                        let hostMapList = {};
                        res2.data.dept_list.map(res=>{
                            res.id = res._id;
                            return deptMapList[res.departmentId] = res;
                        })
                        res2.data.guest_corp_list.map(res=>{
                            return guestMapList[res.dock_corpid] = res;
                        })
                        res2.data.host_corp_list.map(res=>{
                            return hostMapList[res.dock_corpid] = res;
                        })
                        this.setState({
                            corpList: res2.data.our_docker_list.map((val)=>{
                                val.id = val.id;
                                return val;
                            }),
                            deptList: res2.data.dept_list,
                            owner_coprs: res2.data.owner_coprs,
                            deptMapList,
                            guestMapList,
                            hostMapList,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        },()=>{
                            mask && mask.remove();
                            this.closeCheckMenu();
                        })
                    })
                }
                    break;
                case "corpDeptAll":{
                    React.axios("/corp/dock/corp/list_dept",{
                        keyword: "", limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        let deptMapList = {};
                        let guestMapList = {};
                        let hostMapList = {};
                        res2.data.guest_corp_list.map(res=>{
                            return guestMapList[res.dock_corpid] = res;
                        })
                        res2.data.host_corp_list.map(res=>{
                            return hostMapList[res.dock_corpid] = res;
                        })
                        this.setState({
                            corpList: res2.data.our_dept_list.map((val)=>{
                                val.id = val.id;
                                return val;
                            }),
                            owner_coprs: res2.data.owner_coprs,
                            deptMapList,
                            guestMapList,
                            hostMapList,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        },()=>{
                            mask && mask.remove();
                            this.closeCheckMenu();
                        })
                    })
                }
                    break;
                case "corpCoopAll":{
                    React.axios("/corp/dock/corp/guest_list",{
                        keyword: "", limit, skip, role_id, status: inviteStatus
                    }).then((res2)=>{
                        this.setState({
                            corpList: res2.data.guest_corp_list,
                            owner_coprs: res2.data.owner_coprs,
                            count: res2.data.count,
                            isLoading:false,
                            hasGuestCorp: res2.data.guest_corp_list.length > 0,
                        },()=>{
                            mask && mask.remove();
                            this.closeCheckMenu();
                        })
                    })
                }
                    break;
            }
        })

    }

    render(){
        const {hasGuestCorp, corpList, selectGroupName, keyword, guestMapList, hostMapList, isLoading, corpCoopList, contactList, limit, skip, selectGroup, filterText, selectType, checkList, checkListDetail, checked, corpCoopMap, contactMap, count} = this.state;
        const tipList = [
            {
                text: React.language("corp.coop.empty.tip1")
            },{
                text: React.language("corp.coop.empty.tip2")
            },{
                text: React.language("corp.coop.empty.tip3"),
                hasBtn: true
            },
        ];


        let list = []
        list = [{
            width: 177,
            key: "name",
            hasWidth: !0,
            value: React.language("name"),
            title: true,//给元素添加title属性
        }, {
            width: 147,
            key: "create_user",
            hasWidth: !0,
            value: React.language("contact.docking.corp"),
            onCellCreate: (items, value) => {
                let idList = value.corp_id_list ? [...value.corp_id_list] : [];
                let mapList = (guestMapList && hostMapList) ? {...guestMapList, ...hostMapList} : {}
                let titleName = idList.map(res=>{
                    let id = res.indexOf("-") > -1 ? res.split("-")[0] : res
                    return mapList[id] ? mapList[id].dock_corpname : ""
                })
                return <>
                    {value.is_global_docker ? <span className="text">{React.language("contact.corp.all")}</span> : <ul className="user-list" title={titleName.join(",")}>
                        {
                            idList.map(res=>{
                                let id = res.indexOf("-") > -1 ? res.split("-")[0] : res
                                return mapList[id] && <li className="user-item">
                                    <i className="icon-corp-label"></i>
                                    <div className="user-name">{mapList[id] ? mapList[id].dock_corpname : ""}</div>
                                </li>
                            })
                        }
                    </ul>}
                </>
            },
        }, {
            width: 197,
            hasWidth: !0,
            key: "mobile",
            value: React.language("phone"),
        }, {
            width: 116,
            hasWidth: !0,
            key: "email",
            value: React.language("email"),
        }, {
            width: "100%",
            hasWidth: !0,
            key: "empty",
            value: "",
        }];
        if(selectGroup !== "contactAll"){
            list = [{
                width: 177,
                key: "host_corpname",
                hasWidth: !0,
                value: React.language("openLink.auth.name.enterprise"),
                title: true,//给元素添加title属性
            }, {
                width: 147,
                key: "create_user",
                hasWidth: !0,
                value: React.language("manager.creator"),
                onCellCreate: (items, value) => {
                    return <>
                        <span className="text">{value.create_user ? value.create_user.name : ""}</span>
                    </>
                },
            }, {
                width: 197,
                key: "dock_user",
                hasWidth: !0,
                value: React.language("contact.handover.other"),
                onCellCreate: (items, value) => {
                    if(!value.dock_user){
                        return
                    }
                    let nameArray = value.dock_user.map((val)=>{
                        return val.name
                    })
                    return  <ul className="user-list" title={nameArray.join(',')}>
                        {
                            value.dock_user.map((val)=>{
                                const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                return <li className="user-item">
                                    {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                    <div className="user-name">{val.name}</div>
                                </li>
                            })
                        }
                    </ul>
                },
            }, {
                width: 116,
                key: "user",
                hasWidth: !0,
                value: React.language("contact.handover.current"),
                onCellCreate: (items, value) => {
                    if(!value.user){
                        return
                    }
                    let nameArray = value.user.map((val)=>{
                        return val.name
                    })
                    return <ul className="user-list" title={nameArray.join(',')}>
                        {
                            value.user.map((val)=>{
                                const bg = val ? val.name ? BsyUtils.formatUserThumb(val.name.toString()) : '' : '';
                                return <li className="user-item">
                                    {val.avatarurl ? <img src={val.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                    <div className="user-name">{val.name}</div>
                                </li>
                            })
                        }
                    </ul>
                },
            }, {
                width: "100%",
                hasWidth: !0,
                key: "empty",
                value: "",
            }, {
                width: 80,
                hasWidth: !0,
                key: "again",
                value: "",
            }];
        }

        if(selectGroup === "corpDeptAll"){
            list = [{
                width: 177,
                key: "name",
                hasWidth: !0,
                value: React.language("department"),
                title: true,//给元素添加title属性
            }, {
                width: 147,
                key: "create_user",
                hasWidth: !0,
                value: React.language("contact.docking.corp"),
                onCellCreate: (items, value) => {
                    let idList = value.corp_id_list ? [...value.corp_id_list] : [];
                    let mapList = (guestMapList && hostMapList) ? {...guestMapList, ...hostMapList} : {}
                    let titleName = idList.map(res=>{
                        let id = res.indexOf("-") > -1 ? res.split("-")[0] : res
                        return mapList[id] ? mapList[id].dock_corpname : ""
                    })
                    return <>
                        {value.is_global_dept ? <span className="text">{React.language("contact.corp.all")}</span> : <ul className="user-list" title={titleName.join(",")}>
                            {
                                idList.map(res=>{
                                    let id = res.indexOf("-") > -1 ? res.split("-")[0] : res
                                    return mapList[id] && <li className="user-item">
                                        <i className="icon-corp-label"></i>
                                        <div className="user-name">{mapList[id] ? mapList[id].dock_corpname : ""}</div>
                                    </li>
                                })
                            }
                        </ul>}
                    </>
                },
            }, {
                width: "100%",
                hasWidth: !0,
                key: "empty",
                value: "",
            }, {
                width: 80,
                hasWidth: !0,
                key: "again",
                value: "",
            }];
        }
        return(
            <div className="CorpCoopOtherSetPane">
                <div className="corpCoopMenu" >
                    <div className="menu-cont">
                        <div className="menu-list">
                            <div className={"menu-item" + (selectGroup === "contactAll" ? " active":"")} onClick={()=>{
                                this.changeCorpType("contactAll")
                            }}>
                                <div className="item-cont">
                                    <i className="icon-all-docker"></i>
                                    <span>{React.language('contact.handover.current')}</span>
                                </div>
                            </div>
                            <div className={"menu-item" + (selectGroup === "corpDeptAll" ? " active":"")} onClick={()=>{
                                this.changeCorpType("corpDeptAll")
                            }}>
                                <div className="item-cont">
                                    <i className="icon-department"></i>
                                    <span>{React.language('contact.handover.current.dept')}</span>
                                </div>
                            </div>
                            {(hasGuestCorp || !!keyword) && <div className={"menu-item" + (selectGroup === "corpCoopAll" ? " active":"")} onClick={()=>{
                                this.changeCorpType("corpCoopAll")
                            }}>
                                <div className="item-cont">
                                    <i className="icon-all-corp"></i>
                                    <span>{React.language('contact.corp.host')}</span>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="corpCoopContent" ref={this.corpContEl}>
                    <div className={"cont-box "  + (count === 0 ? "noSearch" : "")}>
                        <div className="content-title">
                            <div className="title">
                                <span>{selectGroupName}</span>
                            </div>
                        </div>
                        {!isLoading && <>
                            {
                                ((corpList && corpList.length > 0) || !!keyword) ? 
                                <>
                                    <div className={"box-btn-pane"} style={{padding: checkList.length <= 0 ? "" : "8px 0"}}>
                                        {
                                            checkList.length <= 0 ? <>
                                                {
                                                    <>
                                                        <div className="create-link-btn">
                                                            {selectGroup === "contactAll" && <div className="create-btn" onClick={this.openAddRoleUserPane}>
                                                                <span>{React.language("contact.handover.add")}</span>
                                                            </div>}
                                                            {selectGroup === "corpDeptAll" && <div className="create-btn" onClick={this.openAddRoleDeptPane}>
                                                                <span>{React.language("contact.handover.dept.add")}</span>
                                                            </div>}
                                                        </div>
                                                        <div className="filter-cont">
                                                            <div className="search-input">
                                                                <BsySearchInput
                                                                    placeholder={selectGroup === "corpDeptAll" ? React.language('contact.search.dept') : selectGroup === "corpCoopAll" ? React.language('corp.search') : React.language('contact.search.name')}
                                                                    styleInput={{
                                                                        'width': '200px',
                                                                        height: '32px',
                                                                        lineHeight: '30px'
                                                                    }}
                                                                    value={keyword}
                                                                    getValue={this.getSearchValue}
                                                                    onSearch={this.onSearch}
                                                                    type={window.mode}
                                                                    // iconName="icon-bsy-reportmenu-0"
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </> : <>
                                                <div className="check-menu">
                                                    <div className="close-btn" onClick={this.closeCheckMenu}>
                                                        <i className="icon-close-large"></i>
                                                    </div>
                                                    <div className="total-cont">
                                                        <span className="checked-num-wrapper">
                                                            <span className="checked-title">{React.language('msg.target.set.selected')}</span>
                                                            <span className="checked-num">{checkList.length}</span>
                                                            /{corpList.length}
                                                        </span>
                                                    </div>
                                                    {
                                                        selectGroup !== "contactAll" && selectGroup !== "corpDeptAll" ? <div className="remove-btn" onClick={this.removeCorpLabelBatch}>
                                                            <i className="icon-bsy-reportmenu-5"></i>
                                                            <span>{React.language("contact.connection.remove")}</span>
                                                        </div>:<div className="remove-btn" onClick={this.removeCorpLabelBatch}>
                                                            <i className="icon-bsy-reportmenu-5"></i>
                                                            <span>{React.language("remove.out")}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <BsyTableList 
                                        getValue={this.getTableValue}
                                        key={new Date().getTime()}
                                        limit={limit}
                                        skip={skip}
                                        skipChange={this.skipChange}
                                        listLimitChange={this.listLimitChange}
                                        listFilterChange={this.listFilterChange}
                                        styleType={window.mode}
                                        userCont={{
                                            users:corpList
                                        }}
                                        noDarg={true}
                                        count={count}
                                        hasTurnPage={!!count}
                                        list={list}
                                        checkList={checkList}
                                        checkListDetail={checkListDetail}
                                        checked={checked}
                                        multiple={selectGroup !== 'deleted'}
                                        onRowOrder={e => { this.handleUserOrder(e) }}
                                        onReinvite={e => { this.againAllInvite(e) }}
                                        onRowClick={(e, node) => { this.memberRowClick(e, node) }}
                                        onCheck={(e)=>{this.onCheck(e)}}
                                    />
                                    {
                                        count === 0 && <div className="search-empty-tip">
                                            <div className="empty-cont">
                                                <img src={emptyImg3} alt="" style={{marginBottom: 20}} />
                                                <p>{React.language('contact.all.search.emptyTip')}</p>
                                            </div>
                                        </div>
                                    }
                                </> : <div className="empty-content-tip">
                                    <div className="content-tip">
                                        <div className="empty-img">
                                            <img src={emptyImg2} alt="" style={{marginBottom: 20}} />
                                        </div>
                                        <div className="empty-tip">
                                            {selectGroup === "contactAll" ? React.language('contact.handover.current.add.tip') : selectGroup === "corpDeptAll" ? React.language('contact.dept.current.add.tip') : ""}
                                        </div>
                                        {(selectGroup === "contactAll" || selectGroup === "corpDeptAll") && <div className="empty-button">
                                            <div className="corpButton" onClick={selectGroup === "corpDeptAll" ? this.openAddRoleDeptPane : this.openAddRoleUserPane}>
                                                {selectGroup === "contactAll" ? React.language('contact.handover.add') : React.language('contact.handover.dept.add')}
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            }
                        </>}
                    </div>
                </div>
            </div>
        )
    }
}